import { useContext } from "react";
import { OpstelClientContext, OpstelClientContextProps } from "./OpstelClientContext";

export function useOpstelClient(): OpstelClientContextProps {
  const context = useContext(OpstelClientContext);
  if (!context) {
    throw new Error("useOpstelClient must be used within an OpstelClientProvider");
  }
  return context;
}
